/* eslint-disable max-len */
export default {
  nameDefault: 'Padrão',
  active: 'Ativar',
  active2: 'Ativo',
  disableNotifications: 'Ocultar notificación',
  activeNotifications: 'Mostrar notificación',
  action: 'Ações',
  addNewLimit: 'Adicionar novo limite',
  admin: 'Admin',
  adminUsers: 'Usuários Administradores',
  adminUserRegister: 'Cadastro de usuário administrador',
  adminUserSuccess: 'Novo usuário administrador criado com sucesso!',
  adminUserSuccessUpdate: 'Usuário administrador alterado com sucesso!',
  addEstimateBuy: 'Ir às compras',
  addEstimate: 'Adicionar ao Orçamento',
  address: 'Endereço',
  aboutUs: 'Sobre nós',
  app: 'APP',
  approve: 'Aprovar',
  approved: 'Aprovado',
  refused: 'Recusou',
  approved3: 'Aprovado',
  approved1: 'Aprovador 1',
  approved2: 'Aprovador 2',
  approveError1: 'Aprovador 1 deve ser informado',
  authorized: 'Autorizado',
  clientAutoBilling: 'Faturamento Automático?',
  autoBillingError: 'Faturamento Automático? não selecionado',
  clientCustomerUnit: 'Exibir unidade de medida do cliente?',
  customerUnitError: 'Exibir unidade de medida do cliente? não selecionado',
  projectsForIntegratorsError: 'Projetos para integradores? não selecionado',
  allowSellSpotItensWithoutStock: 'Permitir vender itens SPOT sem estoque?',
  allowSellSpotItensWithoutStockError: 'Permitir vender itens SPOT sem estoque? não selecionado',
  bankSlip: 'Boleto',
  banners: 'Banners',
  banner: 'Banner',
  bannerCreated: 'Banner criado com sucesso.',
  bannerUpdated: 'Banner atualizado com sucesso.',
  bannerRegister: 'Cadastro de Banners',
  bannerImportText1: 'A coluna Nome (name) deve conter no máximo 255 caracteres.',
  bannerImportText2: 'A coluna Url para redirecionamento (redirectUrl) deve conter no máximo 255 caracteres.',
  bannerImportText3: 'A coluna Descrição (description) deve conter no máximo 255 caracteres.',
  manufacturers: 'Fabricantes',
  manufacturerCreated: 'Fabricante criado com sucesso.',
  manufacturerUpdated: 'Fabricante atualizado com sucesso.',
  manufacturerRegister: 'Cadastro de Fabricantes',
  manufacturerImportText11: 'A coluna Nome (name) deve conter no máximo 255 caracteres.',
  manufacturerImportText22: 'A coluna Url para redirecionamento (redirectUrl) deve conter no máximo 255 caracteres.',
  manufacturerImportText33: 'A coluna Descrição (description) deve conter no máximo 255 caracteres.',
  billing: 'Faturamento',
  birthday: 'Data nascimento',
  brand: 'Marca',
  brandId: 'Marca id',
  buttonNotInserted: 'Nome do botão não inserido.',
  bu: 'BU',
  buNotSelected: 'BU não selecionado.',
  business: 'Ramo de Atividade',
  buyButton: 'Botão Comprar (Texto)',
  buyDate: 'Data da compra',
  cashDescount: 'Desconto em reais',
  cancel: 'Cancelar',
  canceled: 'Cancelado',
  cancelOrder: 'Cancelar Pedido',
  category: 'Categoria',
  categoryId: 'Categoria id',
  categories: 'Categorias',
  categoryAssociated: 'Categoria já associada com a marca',
  categoryName: 'Digite o nome da categoria',
  categoryName2: 'Nome da categoria',
  categorySaved: 'Categoria salva com sucesso.',
  categoryUpdated: 'Categoria atualizada com sucesso.',
  categoryFamily: 'Família x Categoria',
  categoryFather: 'Categoria pai',
  categoryFatherExplanation: 'Categoria pai, pode ser tanto o id de uma categoria existente, ou também o nome',
  categoryRoot: 'Categoria raiz',
  categoryAlreadyExists: 'Erro! Não é possível criar uma categoria que já é existente',
  categoryParentNotFound: 'Erro! parentId da categoria é inválido.',
  categorySustainable: 'Produto sustentáveis',
  categoryImportText1: '(É sustentável?) deve conter o valor 0/false para NÃO ou 1/true para SIM.',
  cartUser: 'Aprovar carrinhos (Nivel 2)',
  cart: 'Carrinho',
  captured: 'Efetivado',
  categoryDeleted: 'Categoria excluida com sucesso.',
  categoryHasNotChild: 'Categoria possuí uma categoria filho, não é possível excluir.',
  cantEditAdmin: 'Não é possível editar este usuário',
  cep: 'CEP',
  change: 'Alterar',
  cif: 'CIF',
  cnpj: 'CNPJ',
  cpf: 'CPF',
  city: 'Cidade',
  cidRedispatch: 'CID_REDESPACHO',
  create: 'Criar',
  clientId: 'Cód Emitente',
  client: 'Cliente',
  clients: 'Clientes',
  clientMinimumPurchase: 'Valor Mínimo de Compra (Carrinho)',
  clientMinimumProduct: 'Valor Mínimo de Compra (Produto)',
  clientName: 'Nome do cliente',
  clientNotSelected: 'Cliente não selecionado.',
  clientCreated: 'Cliente criado com sucesso.',
  clientRegister: 'Cadastro de cliente',
  clientWithdraw: 'Exibir opção Cliente retira?',
  clientImportText1: 'A coluna (clientId) deve ser preenchida com o ID do cliente',
  clientImportText2: 'A coluna (Apodo del cliente) deve ser preenchida com o apelido do cliente',
  clientImportText3: 'A coluna (Tipo de flete) deve ser preenchida com o tipo do frete [ cif, fob, redespacho ]',
  clientImportText4: 'A coluna (E-mails) deve ser preenchida utilizando como separador o "ponto e vírgula" [ ; ]',
  clientImportText5: 'A coluna (Sucursal) deve ser preenchida com o código do estabelecimento',
  clientImportText6: 'A coluna (Bodega) deve ser preenchida com o [ (código do estabelecimento)_(código do depósito) ]',
  clientImportText7: 'A coluna (Unidad de negocio (BU)) deve ser preenchida com o código da unidade de negócio',
  clientImportText8: 'A coluna (Condición de pago) deve ser preenchida com o código das condições de pagamento',
  clientImportText9: 'A coluna (Políticas de precios) deve ser preenchida com o código da política de preço',
  clientImportText10: 'A coluna (Exhibir descripción del cliente) deve ser preenchida com 1 para SIM ou 0 para NÃO',
  clientImportText11: 'A coluna (Mostrar opción (Cliente retira)) deve ser preenchida com 1 para SIM ou 0 para NÃO',
  clientImportText12: 'A coluna (Mostrar la unidad de medida del cliente) deve ser preenchida com 1 para SIM ou 0 para NÃO',
  clientImportText29: 'A coluna (Projetos para integradores) deve ser preenchida com 1 para SIM ou 0 para NÃO',
  clientImportText13: 'A coluna (Mostrar producto del contrato sin precio) deve ser preenchida com 1 para SIM ou 0 para NÃO',
  clientImportText14: 'A coluna (Permitir vender artículos SPOT sin stock) deve ser preenchida com 1 para SIM ou 0 para NÃO',
  clientImportText15: 'A coluna (XML) deve ser preenchida com 1 para SIM ou 0 para NÃO',
  clientImportText16: 'A coluna (CSV) deve ser preenchida com 1 para SIM ou 0 para NÃO',
  clientImportText17: 'A coluna (PDF) deve ser preenchida com 1 para SIM ou 0 para NÃO',
  clientImportText18: 'A coluna (JSON) deve ser preenchida com 1 para SIM ou 0 para NÃO',
  clientImportText19: 'A coluna (Botón Comprar (Texto)) deve ser preenchida com o texto do botão para processr a compra no e-shop [ default = "Procesar Compra" ]',
  clientImportText20: 'A coluna (Facturación automática) "Faturamento automático" deve ser preenchida com 1 para SIM ou 0 para NÃO',
  clientImportText21: 'A coluna (Monto Mínimo de Compra (Carrito)) deve ser preenchida apenas com números e utilizar como separador o ponto [ . ]. Caso não seja informado um número válido o sistema utilizará como default 0',
  clientImportText22: 'A coluna (Monto Mínimo de Compra (Producto)) deve ser preenchida apenas com números e utilizar como separador o ponto [ . ]. Caso não seja informado um número válido, o sistema utilizará como default 0',
  clientImportText23: 'A coluna (Código de regla PunchOut) deve ser preenchida com o código da regra PUNCHOUT',
  clientImportText24: 'A coluna (PunchOut ID) deve ser preenchida com o ID do PUNCHOUT',
  clientImportText25: 'A coluna (Código de Proveedor de Punchout) deve ser preenchida com o código do forcedor PUNCHOUT',
  clientImportText26: 'A coluna (Número de Contrato de Punchout) deve ser preenchida com o número do contrato PUNCHOUT',
  clientImportText27: 'A coluna (Permitir Catálogo de Punchout) "Permitir catálogo de PUNCHOUT" deve ser preenchida com 1 para SIM ou 0 para NÃO',
  clientImportText28: 'A coluna (Nombre del Catálogo de Punchout) deve ser preenchida com o nome do catálogo PUNCHOUT',
  company: 'Companhia',
  companyName: 'Razão Social',
  code: 'Código',
  codeSolicitation: 'Código da Solicitação',
  confirm: 'Confirmar',
  confirmPassword: 'Confirmar senha',
  confirmClient: 'Deseja realmente confirmar o cliente?',
  contactId: 'ID do Contato',
  contract: 'Contratos',
  contractId: 'ID do Contrato',
  contractNotSelected: 'Contrato não selecionado',
  contractNumberNotSetted: 'Número de contrato não configurado',
  conveyor: 'Transportadora:',
  complement: 'Complemento',
  consuption: 'Uso_consumo',
  country: 'País',
  credit: 'Crédito',
  creditLimit: 'Limite de crédito',
  created: 'Criado com sucesso',
  createdIn: 'Criado em',
  changedIn: 'Alterado em',
  dateHour: 'Data/ horário da compra',
  dateInit: 'Data do Inicio da Promoção',
  dateFinal: 'Data Final da Promoção',
  initDate: 'Data Inicial',
  finDate: 'Data Final',
  dateLess: 'Data da promoção é menor do que a data atual.',
  dateMajor: 'Data inicial é maior ou igual a data de final da promoção.',
  delete: 'Excluir',
  deleteSpotlightModal: 'Deseja realmente excluir o produto em destaque?',
  deleteCategoryModal: 'Deseja realmente excluir a categoria?',
  deleteProductModal: 'Deseja realmente desativar o produto?',
  disabled: 'Desativado?',
  disableProductBodyModal: 'Deseja realmente desativar o produto?',
  disableProductTitleModal: 'Desativar',
  activeProductBodyModal: 'Deseja realmente ativar o produto?',
  activeProductTitleModal: 'Ativar',
  activeProductModal: 'Deseja realmente ativar o produto?',
  productDisable: 'Produto desativado com sucesso',
  productActive: 'Produto ativado com sucesso',
  deletePromotionModal: 'Deseja realmente excluir a promoção?',
  deletePromotion: 'Deseja realmente excluir as promoções?',
  deleteLimit: 'Excluir',
  delivered: 'Entregue',
  deliveryLocation: 'Local de Entrega',
  deposit: 'Depósito',
  depositNotSelected: 'Depósito não selecionado.',
  mainDeposit: 'Depósito Principal',
  mainDepositNotSelected: 'Depósito principal não selecionado.',
  details: 'Detalhes',
  debit: 'Débito',
  description: 'Descrição',
  descriptionImageRequire: 'Descrição da imagem obrigatório.',
  descount: 'Desconto',
  dragAndDrop: 'Clique aqui para carregar os arquivos.',
  dragAndDropBannerErrorTitle: 'Banners não adicionados:',
  dragAndDropBannerErrorDescription: 'Descrição deve ser informada',
  dragAndDropManufacturerErrorTitle: 'Fabricantes não adicionados:',
  dragAndDropManufacturerErrorDescription: 'Descrição deve ser informada',
  dragAndDropClientErrorNickname: 'Campo nickname inválido',
  dragAndDropClientErrorFreight: 'Campo freight inválido',
  dragAndDropClientErrorPaymentTerm: 'Campo paymentTerms inválido',
  dragAndDropClientErrorBu: 'Campo bu inválido',
  dragAndDropClientErrorLocation: 'Campo locationId inválido',
  dragAndDropClientErrorProjectsForIntegrators: 'Campo inválido (Projetos para integradores)',
  dragAndDropClientErrorPricePolicy: 'Campo pricePolicy inválido',
  dragAndDropClientErrorDeposit: 'Campo deposit inválido',
  dragAndDropClientErrorJSONInvalid: 'Campo fileEmailJson inválido',
  dragAndDropClientErrorXMLInvalid: 'Campo fileEmailXML inválido',
  dragAndDropClientErrorCSVInvalid: 'Campo fileEmailCsv inválido',
  dragAndDropClientErrorPDFInvalid: 'Campo fileEmailPdf inválido',
  dragAndDropClientErrorDisplayClientDescription: 'Campo displayClientDescription inválido',
  dragAndDropClientErrorShowContractProductWithoutPrice: 'Campo showContractProductWithoutPrice inválido',
  dragAndDropClientErrorClientWithdraw: 'Campo clientWithdraw inválido',
  dragAndDropClientErrorAllowSellSpotItensWithoutStock: 'Campo allowSellSpotItensWithoutStock inválido',
  dragAndDropClientErrorAutoBilling: 'Campo autoBilling inválido',
  dragAndDropClientErrorCustomerUnit: 'Campo customerUnit inválido',
  dragAndDropClientErrorProductCatalogPunchout: 'Campo productCatalogPunchout inválido',
  dragAndDropClientErrorClientPunchoutRule: 'Campo punchoutRule no válido',
  dragAndDropClientErrorClientCheckbuyExist: 'Cliente já cadastrado no Checkbuy',
  dragAndDropClientErrorClientSphereDontExist: 'Cliente não está cadastrado no Sphere',
  dragAndDropClientErrorTitle: 'Clientes não adicionados:',
  dragAndDropClientErrorUserNotRegisteredSphere: 'Usuário não registrado no Sphere',
  dragAndDropClientErrorUserNotActiveSphere: 'Usuário nãp ativado no Sphere',
  dragAndDropFeaturedErrorTitle: 'Fabricantes em Destaque não adicionados:',
  dragAndDropFeaturedErrorCategory: 'Categoria não encontrada',
  dragAndDropFeaturedErrorBrand: 'Marca não encontrada',
  dragAndDropFeaturedErrorExist: 'Relacionamento Marca / Categoria já existe.',
  dragAndDropProductErrorTitle: 'Produtos não adicionados:',
  dragAndDropProductErrorSphere: 'Sphere id não encontrado',
  dragAndDropProductErrorCategory: 'Categoria não encontrado',
  dragAndDropPromotionErrorTitle: 'Promoções não adicionadas:',
  dragAndDropPromotionErrorType: 'O Tipo deve ser "value" ou "percentage".',
  dragAndDropPromotionErrorStartedAt: 'Data Início deve estar no formato DD/MM/AA HH:MM.',
  dragAndDropPromotionErrorFinalizedAt: 'Data Fim deve estar no formato DD/MM/AA HH:MM.',
  dragAndDropPromotionErrorProductId: 'Produto não encontrado',
  dragAndDropPromotionErrorSubstituted: 'Promoções Alterada',
  dragAndDropPromotionErrorNotReplaced: 'Esta promoção alterar varias outras promoções',
  dragAndDropUserErrorTitle: 'Usuários não adicionados:',
  dragAndDropUserErrorAccessCart: 'Se cartPermission estiver com valor "N", nenhuma Forma de Pagamento pode ser liberada',
  dragAndDropUserErrorApproveCart: 'Se cartUserPermission estiver com valor "S", alguma Forma de Pagamento deve estar liberada',
  dragAndDropUserErrorVisualizeCart: 'Se cartUsersPermission estiver com valor "S", cartPermission deve estar com "S"',
  dragAndDropUserErrorVisualizePrice: 'Se pricePermission estiver com valor "N", nenhuma Forma de Pagamento pode ser liberada',
  dragAndDropUserErrorUserNotRegisteredSphere: 'Usuário não registrado no Sphere',
  dragAndDropUserErrorUserNotActiveSphere: 'Usuário nãp ativado no Sphere',
  dragAndDropAdminUsersErrorTitle: 'Usuários Administradores não adicionados:',
  dragAndDropAdminUsersErrorEmail: 'E-mail/Usuário já cadastrado no sistema!',
  dragAndDropAdminUsersErrorSubstituted: 'Usuários Administradores Alterados',
  dragBanner: 'Clique aqui para enviar a imagem do banner.',
  dragManufacturer: 'Clique aqui para enviar a imagem do fabricante.',
  dragCategory: 'Clique aqui para enviar a imagem da categoria.',
  disable: 'Desativar',
  district: 'Bairro',
  edit: 'Editar',
  email: 'E-mail',
  emails: 'E-mails',
  emailNotAdded: 'Emails não adicionados.',
  emailNotRegistered: 'Email não cadastrado no sphere',
  end: 'Fim',
  errorOcurred: 'Ocorreu um erro, tente mais tarde.',
  estimate: 'Orçamento',
  exit: 'Sair',
  export: 'Exportar',
  ExportSixtyDays: 'Exportar 60 últimos dias',
  noData: 'Sem Dados',
  noDataPeriod: 'Não há dados para este período',
  failed: 'Falhou',
  failedTotvs: 'Ocorreu uma falha durante a integração com o Totvs. Para reenviar a integração acione o botão de ações ( Reenviar integração ).',
  failedSphere: 'Ocorreu uma falha durante a integração com o Sphere. Para reenviar a integração acione o botão de ações ( Reenviar integração ).',
  family: 'Família',
  familyRegister: 'Cadastro Família x Categoria',
  familyDelete: 'Deseja realmente excluir este relacionamento?',
  freight: 'Frete',
  freightType: 'Tipo de frete',
  freightTypeObs: 'Esta condição de frete será aplicada quando o cliente selecionar Entrega Normal',
  freightNotSelected: 'Frete não selecionado.',
  finalizePurchase: 'Finalizar compra',
  finalizePurchaseCredit: 'Finalizar compra com cartão de crédito',
  finalizePurchaseCreditStock: 'Finalizar compra com produtos sem estoque',
  finalizePurchaseCreditMinDeliveryDate: 'Permitir prazo mínimo de entrega',
  finalizePurchaseDebit: 'Finalizar compra com cartão de débito',
  finalizePurchaseBankSlip: 'Finalizar compra com boleto',
  finalizePurchaseBankSlipStock: 'Finalizar compra com produtos sem estoque',
  finalizePurchaseBankSlipMinDeliveryDate: 'Permitir prazo mínimo de entrega',
  finalizePurchaseBilling: 'Finalizar compra com faturamento',
  fob: 'FOB',
  fullName: 'Nome completo',
  generateCSV: 'Gerar arquivo CSV',
  generateEstimate: 'Gerar orçamento',
  golNotSelected: 'Finalidade não selecionado.',
  icmsDiferido: 'ICMS Diferido',
  icmsIsento: 'ICMS Isento',
  init: 'Início',
  info: 'Info',
  inactive: 'Inativo',
  industrialization: 'Industrialização',
  invalidCsvFile: 'Arquivo inválido, verifique se o arquivo está no formato CSV e padrão correto',
  insertFirstName: 'Insira o nome do usuário.',
  insertDescount: 'Insira o desconto',
  integrated: 'Integrado',
  inTransport: 'Em transporte',
  invoice: 'Faturas emitidas',
  invoiceDone: 'Nota fiscal emitida',
  invoiceNumber: 'Número da nota fiscal',
  invoiceText: 'Nota fiscal ',
  invoicePartially: 'Parcialmente faturado',
  invalidImageFormat: 'Imagem inválida, utilize jpeg, jpg, gif ou png.',
  import: 'Importar',
  importClient: 'Importar cliente',
  importClientUser: 'Importar usuario',
  importClientUsers: 'Importar usuarios de clientes',
  importUser: 'Importar Usuários',
  importProducts: 'Importar Produtos',
  importCategories: 'Importar Categorias/Subcategorias',
  importModel: 'Modelo para importação',
  invalidEmail: 'O e-mail inserido não está em um formato válido',
  importBanners: 'Importar Banners',
  importManufacturers: 'Importar Fabricantes',
  importClients: 'Importar Clientes',
  importFeaturedManufactures: 'Importar Fabricantes em Destaque',
  importPromotions: 'Importar Promoções',
  importAdministrators: 'Importar Administradores',
  importText1: 'Para que a importação ocorra com sucesso é preciso que:',
  importText2: 'A primeira linha deve conter o título da coluna.',
  importText3: 'O arquivo deve estar no formato CSV.',
  importText4: 'Todos os campos são obrigatórios.',
  importText5: 'A primeira linha deve conter o título da coluna todo minúsculo e sem acentos.',
  ipi: 'IPI',
  item: 'Item',
  lastAcess: 'Último acesso',
  lastName: 'Sobrenome',
  layouts: 'Layouts',
  line: 'Linha',
  lines: 'Linhas',
  limitError: 'Os limites não podem ser iguais',
  limitTo: 'limite até',
  limitText: '(Alçada) Limites de finalização de pedido',
  noLimit: 'Não selecionar limite',
  loginText: 'Painel Administrativo do Checkbuy',
  manufacturerImportText1: 'A coluna Marca (brand) deve conter no máximo 255 caracteres e deve estar cadastrada no TECTAG.',
  manufacturerImportText2: 'A coluna Categoria (category) deve conter no máximo 11 digitos.',
  monetarySymbolPrefix: 'R$ ',
  name: 'Nome',
  nameImageRequire: 'Nome da imagem obrigatório.',
  naoContribIcms: 'Não Contribuinte do ICMS',
  newUsers: 'Novos usuários',
  newRegisterUpdate: 'Novo Registro atualizado com sucesso',
  newRegisterUpdateError: 'Novo Registro com erro de atualização',
  nickname: 'Apelido',
  no: 'Não',
  notDefined: 'Não definido',
  notAuthorized: 'Não autorizado',
  notFinalized: 'Não finalizado',
  notification: 'Notificação',
  notificationRegistration: 'Notificación de Registro',
  noInvoices: 'Não há NF\'s',
  number: 'Número',
  opcoHeaderMessage: 'Mensagem site institucional',
  opcoUrlSite: 'Url site institucional',
  paid: 'Pago',
  panel: 'Painel',
  pageNotFound: 'Página não encontrada!',
  password: 'Senha',
  passwordDifferents: 'As senhas são diferentes',
  passwordText: 'As senhas deve ser maior que seis e menor que cinquenta caracteres.',
  noPassword: 'As senhas são um campo obrigatório',
  params: 'Parâmetros',
  payment: 'Pagamento',
  paymentType: 'Tipo Pagamento',
  paymentStatus: 'Pagamento Status',
  paymentCondition: 'Condição de pagamento',
  paymentConditionNotSelected: 'Condição de pagamento não selecionada.',
  paymentDone: 'Pagamento confirmado',
  pendingOrdersCSV: 'Pendentes Aprovação',
  permissionErrorText1: 'Pelo menos um método de pagamento deve ser ativo se Aprovar carrinho estiver selecionado',
  permissionErrorText2: 'Visualizar preço dos produtos deve ser ativo se Aprovar carrinho estiver selecionado.',
  permissionErrorText3: 'Não é possível selecionar: Finalizar compra com cartão de crédito, Finalizar compra com cartão de débito e Finalizar compra com boleto se Visualizar preço dos produtos não estiver selecionada',
  permissionErrorText4: 'Não é possível selecionar: Finalizar compra com cartão de crédito, Finalizar compra com cartão de débito e Finalizar compra com boleto e Finalizar compra com faturamento se Acesso ao carrinho não estiver ativo',
  permissionLabel1: 'Necessário Visualizar preço dos produtos ativo',
  permissionLabel2: 'Necessário Acesso ao carrinho ativo',
  permissionLabel3: 'Necessário Acesso ao carrinho e pelo menos algum método de pagamento ativo',
  permissionLabel4: 'Necessário Finalizar compra com cartão de crédito ativo',
  permissionLabel5: 'Necessário Finalizar compra com boleto ativo',
  percentage: 'Porcentagem',
  percentagemDescount: 'Desconto em porcentagem',
  phone: 'Telefone',
  pisCofins: 'PIS/COFINS',
  place: 'Estabelecimento',
  places: 'Estabelecimentos',
  mainPlace: 'Estabelecimento Principal',
  mainPlaceNotSelected: 'Estabelecimento principal não selecionado.',
  placeNotSelected: 'Estabelecimento não selecionado.',
  placeRegister: 'Cadastro de Estabelecimento',
  placeDelete: 'Deseja realmente excluir este estabelecimento?',
  placeCreated: 'Estabelecimento criado com sucesso',
  placeUpdated: 'Estabelecimento alterado com sucesso',
  stateRequire: 'Campo de Estado é Obrigatório.',
  placeRequire: 'Campo de Estabelecimento é Obrigatório.',
  branch: 'Filial',
  price: 'Preço',
  proEmprego: 'Pró-Emprego (Somente SC)',
  product: 'Produto',
  productCode: 'Código do Produto',
  products: 'Produtos',
  productAdded: 'Produto adicionado com sucesso',
  productImportText1: 'É obrigatório o preenchimento dos campos: Sphere (cód item Sphere), category(Id da categoria) e SPOT .',
  productImportText2: 'O Campo Sphere corresponde ao código do produto. Este deve estar cadastrado no TECTAG e não deve ser um produto obsoleto.',
  productImportText3: 'O Campo Categoria (category) deve ser inserido o número correspondente a ID da Categoria.',
  productImportText4: 'O Campo Descrição (description) deve conter no máximo 100 caracter(es). Se este campo estiver vazio será carregado a descrição do TECTAG.',
  productImportText5: 'O Campo SPOT deve ser preenchido como S, caso queira que o item seja exibido no SPOT e a coluna deve estar com N caso queira que o item não seja exibido no SPOT.',
  productImportText6: 'Se o Campo Marca (brand) estiver vazio será carregado a marca cadastrada no TECTAG.',
  productImportText7: 'O Campo Destaque deve ser preenchido como S, caso queira que o item seja exibido no Destaque e a coluna deve estar com N caso queira que o item não seja exibido no Destaque.',
  productImportText8: 'O Campo SPOT deve ser preenchido como S, caso queira que o item seja exibido no OFERTA e a coluna deve estar com N caso queira que o item não seja exibido no OFERTA.',
  productRegister: 'Cadastro de produtos',
  productUpdated: 'Produto atualizado com sucesso.',
  productDeleted: 'Produto excluido com sucesso.  ',
  promotions: 'Promoções',
  promotionCreated: 'Promoção criada com sucesso.',
  promotionUpdated: 'Promoção atualizada com sucesso.',
  promotionRegister: 'Cadastro de promoções',
  promotionType: 'Tipo de promoção',
  promotionImportText1: 'A coluna Produto (productId) corresponde ao código no TECTAG e deve conter no máximo 20 caracteres.',
  promotionImportText2: 'A coluna Tipo de Promoção (type) deve conter os valores value ou percentage.',
  promotionImportText3: 'A coluna Aparecer relógio para cronometrar? (showTimer) deve conter o valor 0 para NÃO ou 1 para SIM.',
  promotionImportText4: 'A coluna Data do Inicio da Promoção (startedAt) deve estar no formato DD/MM/AA HH:MM:SS. Ex. "01/01/20 08:00:00"',
  promotionImportText5: 'A coluna Data Final da Promoção (finalizedAt) deve estar no formato DD/MM/AA HH:MM:SS. Ex. "15/01/20 18:00:00"',
  promotionImportText6: 'A coluna Valor (value) deve conter no maximo 10 digitos e 2 casas decimais. Ex. "20.00"',
  adminUserImportText1: 'É obrigatório o preenchimento dos campos: name, email, password, status e profileId.',
  adminUserImportText2: 'No campo Status (status) é obrigatório colocar active ou inactive.',
  adminUserImportText3: 'No campo de profileId deve-se inserir o número de uma das opções a seguir:',
  adminUserOptionProfile1: 'Todos os Usuários',
  adminUserOptionProfile2: 'Time Comercial',
  adminUserOptionProfile3: 'Perfil Teste SZ',
  processed: 'Processado',
  providerReturn: 'Código Retorno',
  mainProvider: 'Provedor Principal',
  policy: 'Politica',
  policyNotSelected: 'Politica não selecionado.',
  popupBody: 'Mensagem para o POP-UP em tela inicial',
  punchoutRule: 'Regra PunchOut',
  punchoutRules: 'Regras PunchOut',
  punchoutN1Rules: 'Regras PunchOut Nível 1',
  punchoutN2Rules: 'Regras PunchOut Nível 2',
  punchoutN2Rule: 'Regra PunchOut Nível 2',
  punchoutN1Rule: 'Regra PunchOut Nível 1',
  punchOutRuleCreated: 'Regra de PunchOut criada com sucesso',
  punchOutRuleUpdated: 'Regra de PunchOut atualizada com sucesso',
  punchOutRuleRegister: 'Cadastro de Regra do PunchOut',
  punchoutRuleError: 'Todas as informações devem ser preenchidas',
  purpose: 'Finalidade',
  redirectUrl: 'Url de redirecionamento',
  productBought: 'Produto(s) comprado(s)',
  register: 'Cadastrar',
  registerDate: 'Data do Cadastro',
  registerSolicitation: 'Solicitação de cadastro',
  registerMonitor: 'Monitor de cadastro',
  registerUpdated: 'Última Atualização',
  requestDate: 'Data da solicitação',
  return: 'Voltar',
  returnHome: 'Voltar para Home',
  resale: 'Revenda',
  resendIntegration: 'Reenviar integração',
  role: 'Função',
  screenHome: 'Tela de Início',
  screenProduct: 'Tela de Produto',
  screenCart: 'Tela do Carrinho de Compras',
  save: 'Salvar',
  toSend: 'Enviar',
  saveOrder: 'Ordenar',
  saved: 'Salvo com sucesso',
  search: 'Buscar',
  sector: 'Setor',
  send: 'Enviar',
  settings: 'Configurações',
  selectContact: 'Selecione o contato.',
  selectContract: 'Selecione o contrato.',
  selectDateInit: 'Selecione a data de inicio da promoção.',
  selectDateFinal: 'Selecione a data final da promoção.',
  selectProduct: 'Selecione o produto.',
  selectCategory: 'Selecione a categoria.',
  selectBrand: 'Selecione a marca.',
  selectDescount: 'Selecione o tipo de desconto',
  selectDescription: 'Selecione a descrição do produto.',
  selectImage: 'Selecione a imagem.',
  selectPromotionType: 'Selecione o tipo de promoção.',
  selectEmail: 'Selecione um e-mail',
  separateBySemicolon: "Separados por ponto e virgula ';'",
  spot: 'Spot',
  spotlight: 'Destaque',
  spotlightManufacturer: 'Fabricantes em destaque',
  spotlightManufacturerRegister: 'Cadastro de fabricantes em destaque',
  solicitationUser: 'Usuário Solicitante',
  solicitationUserPunchout: 'Usuário Punchout',
  status: 'Status',
  visibility: 'Visibilidade',
  stopWatch: 'Cronometro',
  state: 'Estado',
  stateRegistration: 'Inscrição Estadual',
  signIn: 'Entrar',
  showDescription: 'Exibir descrição do cliente não selecionado',
  showContractProductWithoutPriceError: 'Mostrar produto de contrato sem o preço não selecionado',
  showClientDescription: 'Exibir Descrição do Cliente?',
  showContractProductWithoutPrice: 'Mostrar produto de contrato sem o preço?',
  showTime: 'Selecione se o cronometro será exibido.',
  showTime2: 'Aparecer relógio para cronometrar?',
  showing: 'Exibindo',
  shoppingCartPermission: 'Permissões compra carrinho',
  sphereId: 'Cód Sphere',
  socialMedia: 'Redes sociais',
  successActualized: 'Atualizado com sucesso.',
  successFile: 'Arquivo enviado com sucesso',
  tectagProductNotFound: 'Produto não está registrado no TecTag, entre em contato com o suporte.',
  tectagProductBrandNotFound: 'Registro do produto no TecTag não possui marca, entre em contato com o suporte.',
  type: 'Tipo',
  titleExibition: 'Titulo de Exibição',
  total: 'Total',
  orders: 'Pedidos',
  ordersCheckbuy: 'Pedidos Checkbuy',
  ordersPunchout: 'Pedidos Punchout',
  orderDone: 'Pedido realizado',
  orderDelivered: 'Pedido entregue',
  orderDetails: 'Detalhes do Pedido',
  ok: 'OK',
  quantity: 'Qtd: ',
  userBlocked: 'Usuário está bloqueado.',
  userNotFound: 'Usuário não encontrado.',
  userInvalidPassword: 'Senha inválida.',
  userInvalid: 'Usuário ou senha inválida.',
  update: 'Atualizar',
  resend: 'Reenviar',
  user: 'Usuário',
  users: 'Usuários',
  userCreated: 'Usuário criado com successo',
  userRegister: 'Cadastro de usuário',
  userForm: 'Formulário de usuário',
  undefined: 'Indefinido',
  urlToRedirect: 'Url para redirecionamento',
  urlToRedirectInternal: 'Url para redirecionamento Interno',
  urlToRedirectExternal: 'Url para redirecionamento Externo',
  uploadUserText1: 'Para que a importação ocorra com sucesso é preciso que:',
  uploadUserText2: 'A primeira linha deve conter o título da coluna.',
  uploadUserText3: 'O arquivo deve estar no formato CSV.',
  uploadUserText4: 'Todos os campos são obrigatórios.',
  uploadUserText5: "A coluna 'role' considere '1' para 'admin' e '0' para 'usuário'.",
  uploadUserText6: "As colunas de permissões(Permission) considere o valor 'S' para sim e 'N' para não.",
  uploadUserText7: 'Campos de Ids com no máximo 10 números',
  uploadUserText8: 'Todos os campos não mencionados com no máximo 255 caracteres.',
  uploadUserText9: 'Referência de campos : ',
  uploadUserText10: '(E-mail do usuário), ',
  uploadUserText11: '(Id do cliente), ',
  uploadUserText12: '(Id dos contratos separados por -), ',
  uploadUserText13: '(Nome do usuário), ',
  uploadUserText14: '(Senha do usuário), ',
  uploadUserText15: '(Papel de admin/usuário), ',
  uploadUserText16: '(Permissão para visualizar carrinho), ',
  uploadUserText17: '(Permissão para visualizar carrinhos de outros usuários), ',
  uploadUserText18: '(Permissão para efetuar uma compra), ',
  uploadUserText19: '(Permissão para efetuar pagamento com cartão de crédito), ',
  uploadUserText20: '(Permissão para efetuar pagamento com cartão de débito), ',
  uploadUserText21: '(Permissão para efetuar pagamento com boleto), ',
  uploadUserText22: '(Permissão para faturar), ',
  uploadUserText23: '(Permissão para fazer orçamento), ',
  uploadUserText24: '(Permissão para produtos similares), ',
  uploadUserText25: '(Permissão de painel), ',
  uploadUserText26: '(Permissão de estoque), ',
  uploadUserText27: '(Permissão de prazo de entrega), ',
  uploadUserText28: '(Permissão de cross selling), ',
  uploadUserText29: '(Permissão de ver preço), ',
  uploadUserText30: '(Permissão de código do cliente), ',
  uploadUserText31: '(Permissão para pedido ir para o sphere), ',
  uploadUserText32: '(Permissão para receber email), ',
  uploadUserText33: '(Permissão para visualizar produto spot),',
  uploadUserText34: '(Permissão para visualizar código Opco),',
  uploadUserText35: '(Permissão para visualizar código Sonepar),',
  uploadUserText36: '(Permissão para visualizar todos os carrinhos).',
  value: 'Valor',
  valueMajor: 'O valor deve ser maior ou igual a 0.1',
  valueManjorLess: 'O valor deve ser maior que 0 e menor que 100',
  visualization: 'Visualização',
  visualizeCart: 'Acesso ao carrinho',
  visualizeSimilarity: 'Visualizar produtos similares',
  visualizePanel: 'Visualizar painel',
  visualizeStock: 'Visualizar estoque',
  visualizeLeadtime: 'Visualizar lead-time',
  visualizeCrossselling: 'Visualizar produtos cross-selling',
  visualizePrice: 'Visualizar preço dos produtos',
  visualizeClientCode: 'Adicionar número ordem de compra no carrinho',
  visualizeSpot: 'Visualizar produtos em spot',
  visualizeOrder: 'Ver pedido',
  visualizeOpicCode: 'Visualizar código ',
  visualizeSoneparCode: 'Visualizar código Sonepar',
  visualizeInvoices: 'Ver NF\'s',
  visualizeAllOrders: 'Visualizar todos os pedidos',
  yes: 'Sim',
  waiting: 'Aguardando',
  waitingSphere: 'Solicitação aguardando aprovação do Sphere',
  branchTectag: 'Marca Tectag',
  updateBrandTectag: 'Alterar marca do Tectag?',
  descriptionTectag: 'Descrição e-commerce Tectag',
  updateDescriptionTectag: 'Alterar descrição Tectag?',
  recommendedImportText1: 'É obrigatório o preenchimento dos campos: Sphere (cód item Sphere), category(Id da categoria) e SPOT .',
  recommendedImportText2: 'O Campo Categoria (category) deve ser inserido o número correspondente a ID da Categoria.',
  importRecommendeds: 'Importação de Recomendações de produto',
  dragAndDropRecommendedErrorProductCode: 'Produto não adicionado ou inválido',
  dragAndDropRecommendedErrorCategoryId: 'Categoria não adicionado ou inválido',
  dragAndDropRecommendedErrorId: 'Já existe um registro para o produto informado',
  dragAndDropRecommendedErrorTitle: 'Recomendsações de produto não adicionados',
  recommendeds: 'Recomendações Produtos',
  recommendedRegister: 'Cadastro de Recomendações',
  recommendedCreated: 'Recomendação criado com sucesso.',
  recommendedUpdated: 'Recomendação atualizado com sucesso.',
  deleteRecommendedModal: 'Deseja realmente excluir a recomendação de produto?',
  profile: 'Perfil',
  accessProfiles: 'Perfis de Acesso',
  accessProfileRegister: 'Cadastro de Perfil de Acesso',
  accessProfileUpdated: 'Perfil de Acesso alterado',
  accessProfileCreated: 'Perfil de Acesso criado',
  admMenus: 'Menus Administrativo',
  admMenuRegister: 'Cadastro de Menu Administrativo',
  admMenuCreated: 'Menu criado',
  admMenuUpdated: 'Menu Alterado',
  parentMenu: '  Menu relacionado ',
  level: 'Nível',
  title: 'Título',
  relevance: 'Relevância',
  pathCode: 'Código Caminho',
  permissions: 'Permissões',
  checkAll: 'Marcar Todos',
  uncheckAll: 'Desmarcar Todos',
  showMenu: 'Mostrar no menu',
  wrongLevel: 'Nível inválido',
  levelRequire: 'Nível requerido',
  parentMenuRequire: 'Menu relacionado requerido',
  noAccessPermissionCode: 'Sem pemissão de acesso. Código programa:',
  newItemVendor: 'Código do Fornecedor Punchout',
  newItemContract: 'Número do Contrato Punchout',
  allowPunchoutCatalog: 'Integração PunchOut Nível 2 (Catálago CIF)',
  catalogName: 'Nome do Catálago Punchout',
  catalogNameError: 'Nome do Catálogo deve ser informado',
  saoPauloCustomersEstablishment: 'Clientes do Estado de São Paulo:',
  establishmentCustomersOutsideSaoPaulo: 'Clientes Fora do Estado de São Paulo:',
  accessLogin: 'Login de Acesso',
  initialDate: 'Data Inicial',
  finalDate: 'Data Final',
  generateReport: 'Gerar Relatório',
  noOptions: 'Sem opções',
  categoryShopBottomMenu: 'Categorias do menu horizontal',
  awaitPayment: 'Aguardando Pagamento',
  offer: 'Oferta',
  popupBodyButtonLabel: 'Mensagem Botão POP-UP na tela de início',
  popupBodyURL: 'Url botão POP-UP na tela de início',
  exportProducts: 'Exportar Preços',
  EnterCode: 'Informe o código do emitente',
  EnterType: 'Informe o tipo do produto',
  customerProducts: 'precos-clientes.csv',
  warning: 'Aviso',
  disabledPromotions: 'Promoções Modificadas',
  disabledAdminUsers: 'Usuários Administradores Modificados',
  existingPromotion: 'Ja existe uma promoção ativa para este produto, deseja modificar?',
  deleteSelected: 'Deletar Selecionadas',
  limitContract: 'limite por contrato',
  withoutChange: 'Não se aplica',
  limitBlockedContract: 'Bloquear botão',
  limitContractNotice: 'Mensagem de aviso',
  orderingBanners: 'Ordenação dos Banners',
  selectBanner: 'Selecione o Banner',
  bannersCurrentlyActive: 'Nenhum banner ativos no momento',
  download: 'Download',
  contactUs: 'Fale Conosco',
  whatsapp: 'Whatsapp',
  mobile: 'Mobile',
  environment: 'Ambiente',
  deactivatedClient: 'cliente desativado',
  customerDisabledNotice: 'Não é possível ativar o usuário e o cliente ser ativado',
  discountCoupon: 'Cupom de Desconto',
  couponCode: 'Código cupom',
  couponDescription: 'Descrição do cupom',
  startDate: 'Data do Início',
  endDate: 'Data do Fim',
  couponRegistration: 'Cadastro de Cupons',
  minimumValue: 'Valor Mínimo',
  couponType: 'Tipo do Cupom',
  couponStartDate: 'Data do Início do Cupom',
  couponEndDate: 'Data Final do Cupom',
  amountOfUse: 'Límite de Cupón',
  timesUsed: 'N° vezes utilizada',
  clean: 'Limpar',
  historic: 'Histórico',
  allCustomers: 'Todos os Clientes',
  allSelectedCustomer: 'Todos cliente selecionados',
  erro: 'Error',
  erroFetch: 'Erro ou buscar os dados',
  couponDisabled: 'cupom desativado',
  noticeToEditCoupon: 'O cupom não pode ser editado se estiver desativado',
  changeMade: 'Alteração realizada com sucesso',
  registrationPerformed: 'cadastro realizado com sucesso',
  discount: 'Desconto',
  discountCouponHistory: 'Histórico Cupom de Desconto',
  orderCode: 'Código Pedido',
  activeOrder: 'Pedido Ativo',
  orderCanceled: 'Pedido Cancelado',
  dateOfUse: 'Data de Uso',
  importDiscountCoupons: 'Importar Cupons de Desconto',
  couponsNotAdded: 'Cupons Não Adicionados',
  couponsNotAddedNotFound: 'informe este campo',
  couponsNotAddedCharactersNotAllowed: 'Caracteres Não Permitido',
  couponsNotAddedAlreadyUsed: 'já utilizado em outro cupom',
  couponsNotAddedErrorFindingCustomer: 'erro ao localizar cliente',
  couponsNotAddedErrorFindingBrands: 'erro ao localizar as marcas',
  couponsNotAddedOnlyAcceptsNumbers: 'So é aceita números',
  couponsNotAddedOnlyIntegersAreAccepted: 'So é aceita números inteiro',
  couponsNotAddedInvalidFormat: 'Formato inválido',
  couponsNotAddedMinorDate: 'Menor que a data atual',
  couponsNotAddedMinorEndDate: 'Tem que ser maior que a data inicial',
  couponsNotAddedAndAccepted: 'So e aceito 0 ou 1',
  couponsNotAddedBiggerNumbers: 'So e aceito valor maior que 0',
  couponsNotAddedPercentageLimit: 'So e aceito 2 caractere na porcentagem',
  couponsNotAddedTheMinimumValue: 'O valor minimo tem que ser maior que 1',
  successfulImportMessage: 'Foi possível importar %{0} linhas do arquivo',
  mandatory: 'Obrigatório',
  importCouponsText1: '(couponCode) deve ser informado o código cupom contempo apenas numeros, letras, _',
  importCouponsText2: '(description) se debe informar la descripción del cupón',
  importCouponsText3: '(client) deve ser informado apenas os codigos dos clientes separado por virgila ou * para repersentar todos os clientes',
  importCouponsText11: '(brands) deve ser informado apenas os codigos das marcas separado por virgila ou * para repersentar todos as marcas',
  importCouponsText4: '(amountOfUse) numero de vezes que o cupom pode ser usado por clietes diferestes',
  importCouponsText5: '(initialDate)deve ser informado a data de início do cupom no formato DD/MM/YYYY hh:mm',
  importCouponsText6: '(finalDate) deve ser informado a data final do cupom no formato DD/MM/YYYY hh:mm',
  importCouponsText7: '(minimumValue) E o valor mínimo que o pedido deve ter para o cupom pode ser utilizado',
  importCouponsText8: '(type) o tipo de cupom 0 valor, 1 Porcentagem',
  importCouponsText9: '(value) e o valor que o cupom vai ter',
  importCouponsText10: '(status) E o status do cupom, 0 Ativo, 1 Desativo',
  segment: 'Setor',
  customerUserNotAdded: 'Usuário cliente não adicionados',
  informThisField: 'Informe este campo',
  customerNotRegistered: 'Cliente não cadastrado',
  userNotRegisteredSphere: 'Usuário não cadastrado no sphere',
  userNotActiveSphere: 'Usuário não ativado no Sphere',
  userAlreadyRegistered: 'Usuário já cadastrado',
  duplicateLine: 'Linha duplicada',
  contractNotFound: 'Contrato não localizado',
  valueNotAllowedForThisField: 'Valor não permitido para este campo',
  notCorrespondWithRegisteredData: 'Valor não corresponde com dados cadastrados',
  cannotHaveApprover: 'parâmetro (cartUsersPermission) ativo nao pode ter aprovador',
  cannotHaveApprovingPaymentTerms: 'parâmetro (purchaseCreditPermission, purchaseDebitPermission, purchaseBankSlipPermission, purchaseBillingPermission) ativo nao pode ter aprovador',
  uninformed: '(approveId1) não c',
  unregisteredUser: 'Usuário não cadastrado',
  userNotAllowed: 'Usuario sem permissão para ser aprovado',
  importClientUsers1: '(clientId) Deve ser informado o código do cliente',
  importClientUsers2: '(email) Deve ser informado o email do usuário',
  importClientUsers3: '(password) Deve ser informado a senha para o usuário',
  importClientUsers4: '(%{0}) de (%{1}), Informe só o código separado por ,',
  importClientUsers5: '(%{0}) de (%{1}), S para sim N para não',
  importClientUsers6: '(%{0}) de (%{1}), Informe só o código',
  importClientUsers7: '(%{0}) de (%{1}), Informar e-mail do aprovador',
  importClientUsers8: '(%{0}) de (%{1}), Informar o valor',
  filterOrderType: 'Filtrar pedidos',
  filterOrderType1: 'Todos os pedidos',
  filterOrderType2: 'Somente Tradicionais',
  filterOrderType3: 'Somente PunchOut',
  ToFinish: 'Para finalizar',
  toConfirm: 'Por confirmar',
  pending: 'Pendente',
  solicitationCompleted: 'Solicitação concluída',
  forceCompletion: 'Forçar a finalização',
  deleteCoupon: 'Excluir Cupom',
  deleteNotify: 'Excluir Notificação',
  canNotBeUndone: 'Esta ação nao pode ser desfeita',
  greenPortfolio: 'Portifólio Verde',
  position: 'posição',
  cancelThisRequest: 'Deseja cancelar essa solicitação?',
  productFeedbackReason: 'Motivo de Feedback do Produto',
  idReason: 'ID do Motivo',
  reason: 'Motivo',
  registerProductFeedbackReason: 'Cadastrar Motivo de Feedback do Produto',
  editProductFeedbackReason: 'Editar Motivo do Feedback do Produto',
  disabledRecord: 'Registro desativado',
  noticeToProductFeedbackReason: 'O (Motivo de Feedback do Produto) não pode ser editado se desativado',
  companyLogo: 'Logo do cliente',
  chooseFile: 'Escolher arquivo',
  logoCurrentlyActive: 'Nenhum arquivo selecionado',
  fileError: 'Erro ao enviar o arquivo da logo do cliente',
  errorAttachingFile: 'Erro ao anexar o arquivo',
  InvalidFileExtension: 'A extensão do arquivo é inválida',
  clientOrderType: 'Tipo de atendimento do pedido',
  TotalBilling: 'Faturamento total',
  ParcialBilling: 'Faturamento parcial',
  orderTypeError: 'Tipo de atendimento do pedido não selecionado',
  brands: 'Marcas',
  allBrandsSelected: 'Todas as marcas selecionadas',
  allBrands: 'Todas as marcas',
  estimateConvertedToOrder: 'Orçamento convertida em pedido',
  close: 'Fechar',
  visualize: 'Visualizar',
  purchaseFeedback: 'Feedback da Compra',
  userFeedbackTitle: 'Feedback do usuário:',
  userFeedbackScore: 'Nota do Feedback:',
  feedbackDetails: 'Detalhes do Feedback da Compra',
  filter: 'Filtrar',
  dateFieldsNotReported: 'os campos de data não foram informados',
  fieldsNotReported: 'Los campos no fueron informados',
  startDateAndGreater: 'A data inicial e maior que a data final',
  punchoutUserIdentification: 'Identificação usuário PunchOut',
  selectRequiredParameters: 'Selecione quais parâmetros serão obrigatórios',
  enableParameters: 'Habilitar parâmetros',
  projectsForIntegrators: 'Projetos para integrantes',
  technicalMaterial: 'Material técnico',
  coursesAndTraining: 'Cursos e treinamentos',
  courseName: 'Nome do curso',
  certificate: 'Certificado',
  date: 'Data',
  Hour: 'Hora',
  opportunities: 'Oportunidades',
  efkCode: 'Codigo EFK',
  projectName: 'Nome do Projeto',
  director: 'Diretor',
  segment2: 'Segmento',
  stage: 'Etapa',
  projectsDirectory: 'Diretório de Projetos',
  importCoursesAndTraining: 'Importar Cursos e treinamentos',
  notImported: 'Não importado',
  notFound: 'informe este campo',
  invalidFormat: 'Formato inválido',
  importTechnicalMaterial: 'Importar Material Técnico',
  importProjectsDirectory: 'Importar Diretório do Projeto',
  id: 'ID',
  projectsDirectoryText1: 'Coluna (codigo efk) deve ser preenchido apenas com números',
  projectsDirectoryText2: 'Coluna (inversion usdmm) deve ser preenchido apenas com números',
  UpdateTechnicalMaterial: 'Atualizar Material técnico',
  numberOfStudents: 'Número de estudantes',
  instructors: 'Instrutores',
  UpdateCoursesAndTraining: 'Atualizar Cursos e treinamentos',
  usdmmInvestment: 'Investimento usdmm',
  region: 'Região',
  objective: 'Objetivo',
  location: 'Localização',
  descriptionOfWorksAndActivities: 'Descrição das obras e atividades',
  usefulLife: 'Vida util',
  mainTeams: 'Time principal',
  investment: 'Investimento',
  timeline: 'Linha do tempo',
  statusAtSea: 'Estado do sea',
  others: 'Outros',
  UpdateProjectsDirectory: 'Atualizar Diretório do Projeto',
  managerEmail: 'Preencher e-mail do gestor',
  finalizePurchasePaymentGateway: 'Getnet',
  getnetTypeOPayment: 'Getnet (Tarjeta de crédito, débito o prepago)',
  partial: 'Parcial',
  dateApproved1: 'Data primeiro aprovador',
  dateApproved2: 'Data segundo aprovador',
  minBillingDate: 'Data mínima faturamento',
  code2: 'Código:',
  soneparCode: 'Código Sonepar:',
  clientCode: 'Código do Cliente:',
  typeBanner: 'Tipo do banner',
  applicantsName: 'Nome e sobrenome',
  email2: 'E-mail',
  province: 'Bairro',
  message: 'Mensagem',
  requestType: 'Sección de la solicitud',
  referenceId: 'Id de referência',
  nameReference: 'Nome referência',
  contact: 'Contato',
  feedbackMedianRating: 'Nível médio de satisfação',
  BannersMain: 'Banners Principal',
  integratorContactList: 'Lista de contatos do integrador',
  clientSolicitationType: 'Solicitante define endereço de entrega?',
  statusApprover1: 'Status Aprovador 1',
  statusApprover2: 'Status Aprovador 2',
  open: 'Aberto',
  solicitationDate: 'Data Solicitação',
  identifyInternalDeliveryLocation: 'Solicitante identifica local interno de entrega?',
  erpCode: 'Código do ERP',
  initialDateNotFound: 'Data inicial não encontrada',
  invalidInitialDate: 'Data inicial inválida',
  finalDateNotFound: 'Data final não encontrada',
  invalidFinalDate: 'Data final inválida',
  dateGreaterThanToday: 'A data inicial e final não pode ser maior do que a data de hoje',
  initialDateGreaterThanFinalDate: 'A data inicial não pode ser maior que a data final',
  unknownError: 'Erro desconhecido, tente novamente mais tarde.',
  unmappedError: 'Erro não mapeado, tente novamente mais tarde',
  reportGeneratedSuccessfully: 'Relatório gerado com sucesso',
  dataNotFound: 'Nenhum dado encontrado',
  errorCategory: 'Erro ao ativar/desativar a categoria',
  successCategory: 'Categoria "%{0}" desativada com sucesso, com o total de %{1} produtos desativados',
  showCategoryName: 'Categoria %{0} ativada com sucesso',
  changeStatus: 'Alterar Status',
  changeCategoryStatusModal: 'Atenção, ao desativar a categoria "%{0}" também será desativado os produtos e as subcategorias relacionados. Deseja continuar mesmo assim?',
  categoryNotActivated: 'Categoria não está ativada',
  categoryNotFound: 'Categoria não encontrada',
  buttonName: 'Nome do botão',
  productNotFound: 'Produto não encontrado',
  notificationHistory: 'Histórico de notificação',
  hide: 'Ocultar',
  viewMore: 'Ver mais...',
  sendDate: 'Data e hora de envio',
  previewDate: 'Data e hora de exibição',
  filterProducts: 'Filtro produtos',
  web: 'Site',
  webMobile: 'site Mobile',
  displayOn: 'Exibir em',
  bell: 'Campainha',
  viewPercentage: 'Abertos',
  notificationEmail: 'E-mail de notificação',
  notificationEmailRegistration: 'Registro de e-mail de notificação',
  getnetPayment: 'Pagamento Getnet',
  reCaptchaValidationFailed: 'Falha na verificação do reCAPTCHA',
  typeSolution: 'Tipo de Solução',
  typeSolutionRegistration: 'Registro de Tipo de Solução',
  deleteTypeSolution: 'Deseja excluir o Tipo de Solução?',
  cableCategory: 'Categoria de Cabo',
  cableCategoryRegistration: 'Registro de Categoria de Cabo',
  typeCoating: 'Tipo de Revestimento',
  typeCoatingRegistration: 'Registro de Tipo de Revestimento',
  productTelecomRegistration: 'Registro de Produtos',
  supplierTelecomRegistration: 'Registro de Fornecedores',
  formula: 'Fórmula',
  result: 'Resultado',
  fixedValue: 'Valor Fixo',
  meters: 'Metros',
  points: 'Pontos',
  operators: 'Operadores',
  errorFormula: 'Erro na fórmula...',
  sum: 'Somar',
  reduce: 'Diminuir',
  multiply: 'Multiplicar',
  divide: 'Dividir',
  openParentheses: 'Abre Parênteses',
  closeParentheses: 'Fecha Parênteses',
  removeTheLast: 'Remover o Último',
  removeAll: 'Remover Tudo',
  emptyFormula: 'Não pode deixar a formula vazia!',
  purchaseReport: 'Relatório de Pedidos',
  analytics: 'Analytics',
  analyticsLive: 'Ao vivo',
  analyticsHistory: 'Histórico',
  analyticsActiveUsers: 'Usuários ativos',
  analyticsSessions: 'Sessões',
  analyticsPurchaseRevenue: 'Receita de compras',
  analyticsTopPages: 'Páginas principais',
  analyticsPagePath: 'Página',
  analyticsPageViews: 'Visualizações',
  analyticsFunnel: 'Funil',
  analyticsFunnelAddToCart: 'Adicionar ao carrinho',
  analyticsFunnelBeginCheckout: 'Iniciar checkout',
  analyticsFunnelPurchase: 'Compra',
  analyticsTimeseries: 'Série temporal',
  analyticsDate: 'Data',
  analyticsValue: 'Valor',
  analyticsUpdatedAt: 'Atualizado em',
  analyticsEmpty: 'Sem dados sincronizados para o período',
  analyticsEmptyLive: 'Sem dados ao vivo no momento',
  analyticsSeeLiveForNow: 'Para dados de agora, use a aba Ao vivo',
  analyticsLakeOff: 'Exportação lake desativada',
  analyticsLakePending: 'Pendentes no lake: %{count}',
  analyticsSourceDirect: 'Consulta direta GA4',
  analyticsDbSync: 'Último sync BD',
  analyticsCached: 'Cache',
  analyticsLoading: 'Carregando…',
  analyticsRefresh: 'Atualizar',
  analyticsStale: 'Sincronização atrasada — verifique o job',
  analyticsCount: 'Quantidade',
  analyticsOverview: 'Resumo',
  analyticsChartsTitle: 'Gráficos do período',
  analyticsKpiCommerce: 'Comércio',
  analyticsKpiCommercial: 'Resumo comercial',
  analyticsKpiEngagement: 'Engajamento e conta',
  analyticsOverviewFunnel: 'Funil do período',
  analyticsTabTraffic: 'Tráfego',
  analyticsTabFunnel: 'Funil',
  analyticsTabProduct: 'Produto',
  analyticsTabAuth: 'Auth',
  analyticsTabRefund: 'Reembolso',
  analyticsViewItem: 'Visualização de produto',
  analyticsLogin: 'Login',
  analyticsSignUp: 'Cadastro',
  analyticsRefunds: 'Reembolsos',
  analyticsRefundRevenue: 'Receita de reembolsos',
  analyticsMethod: 'Método',
  analyticsItem: 'Produto',
  analyticsTopItems: 'Produtos principais',
  analyticsAuthMethods: 'Métodos de autenticação',
  analyticsAddToCart: 'Adicionar ao carrinho',
  analyticsBeginCheckout: 'Iniciar checkout',
  analyticsPurchases: 'Compras',
  analyticsReports: 'Relatórios',
  analyticsReportsNew: 'Novo relatório',
  analyticsTabEngagement: 'Engajamento',
  analyticsSolicitudNuevosUsuarios: 'Solicitação novos usuários',
  analyticsCantidadCotizaciones: 'Quantidade de cotações',
  analyticsMontoCotizaciones: 'Valor cotações',
  analyticsGenerateEstimate: 'Cotações geradas',
  analyticsRegistrationRequest: 'Solicitações de cadastro',
  analyticsGenerateLead: 'Leads gerados',
  analyticsAddToWishlist: 'Lista de desejos',
  analyticsSearch: 'Buscas',
  analyticsContactClick: 'Contato',
  analyticsRemoveFromCart: 'Remover do carrinho',
  analyticsAddShippingInfo: 'Frete informado',
  analyticsAddPaymentInfo: 'Pagamento informado',
  analyticsJourney: 'Jornada do cliente',
  analyticsJourneyIntro: 'Veja passo a passo o que cada cliente fez na loja: login, produtos vistos, carrinho, checkout e compra. Os eventos vêm do site (com cookies aceitas) — diferente do Histórico, que mostra totais agregados do GA4.',
  analyticsJourneySearch: 'Encontrar cliente',
  analyticsJourneySearchHint: 'Digite pelo menos 2 caracteres do nome, e-mail ou empresa. Depois clique em um resultado para ver a linha do tempo dos últimos 7 dias.',
  analyticsJourneySearchPlaceholder: 'Ex.: maria@empresa.cl ou nome do cliente…',
  analyticsJourneySelectHint: 'Busque um cliente acima para ver a jornada dele.',
  analyticsJourneyNoResults: 'Nenhum cliente encontrado para essa busca.',
  analyticsJourneyNoResultsHint: 'Confira a grafia ou tente outro termo (e-mail parcial, nome ou razão social).',
  analyticsJourneyEmpty: 'Não há eventos registrados para este cliente nos últimos 7 dias.',
  analyticsJourneyEmptyHint: 'Pode ser que a pessoa não tenha navegado logada, tenha recusado cookies ou ainda não tenha ações rastreadas neste ambiente.',
  analyticsJourneyTimeline: 'Linha do tempo',
  analyticsJourneyTimelineSubtitle: 'Eventos em ordem cronológica (últimos 7 dias, fuso Chile).',
  analyticsJourneyLastAction: 'Última ação',
  analyticsJourneyResultsTitle: 'Clientes encontrados — clique para ver a jornada',
  analyticsJourneyPage: 'Página',
  analyticsSearchTerm: 'Termo',
  analyticsTransactionId: 'Pedido',
  analyticsLeadType: 'Tipo de lead',
  analyticsAdvancedShow: 'Relatórios personalizados (avançado)',
  analyticsAdvancedHide: 'Ocultar relatórios personalizados',
  analyticsReportsEdit: 'Editar relatório',
  analyticsReportsName: 'Nome',
  analyticsReportsMetrics: 'Indicadores',
  analyticsReportsBreakdown: 'Detalhamento',
  analyticsReportsBreakdownNone: 'Nenhum',
  analyticsReportsBreakdownTopPages: 'Top páginas',
  analyticsReportsBreakdownTopItems: 'Top produtos',
  analyticsReportsBreakdownAuth: 'Auth por método',
  analyticsReportsDefaultRange: 'Período padrão',
  analyticsReportsSave: 'Salvar',
  analyticsReportsCancel: 'Cancelar',
  analyticsReportsDeleteConfirm: 'Excluir este relatório?',
  analyticsReportsEmptyList: 'Nenhum relatório salvo',
  analyticsReportsRunEmpty: 'Sem dados sincronizados para o período',
  analyticsReportsOpen: 'Abrir',
  analyticsReportsNameRequired: 'Informe o nome do relatório',
  analyticsReportsMetricsRequired: 'Selecione ao menos um indicador',
  analyticsReportsRangeDays: '%{count} dias',
  analyticsHomeCta: 'Ver Analytics',
  analyticsHomeTitle: 'Resumo',
  supplier: 'Fornecedor',
  resendPassword: 'Reenviar Senha',
  resendPasswordNotice: 'Será gerada uma nova senha e será enviada diretamente para o email do usuário.',
  resendPasswordSuccess: 'O e-mail com a nova senha foi enviado.',
  editar: 'Editar',
  new: 'Novo',
  applicationType: 'Tipo Aplicación',
  voltage: 'Voltage',
  start: 'Início',
  voltageRange: 'Voltage Range',
  powerRange: 'Range de Potencia',
  powerRangeStart: 'kW Inicial',
  powerRangeEnd: 'kW Final',
  kw: 'kW',
  hp: 'HP',
  power: 'Potencia',
  importAutomationProductsText1: '(productCode) Deve ser informar o código do produto',
  importAutomationProductsText2: '(applicationType) Deve ser informado o tipo de aplicação',
  importAutomationProductsText3: '(voltageRange) Deve ser informado o intervalo de voltagem',
  importAutomationProductsText4: '(power) Deve ser informada a potência',
  importAutomationProductsText5: '(status) E o status do cupom, 0 Ativo, 1 Desativo',
  automationProductsNotFound: 'informe este campo',
  automationProductsRecordNotFound: 'Registro nao localizado',
  automationProductsAndAccepted: 'So e aceito 0 ou 1',
  automationProductsDuplicateRecord: 'Registro duplicado',
  productsNotAdded: 'produtos não adicionados',
  dateEffective: 'Data de vigência',
  dateExpiration: 'Data de validade',
  sales: 'Vendas',
  selectStatus: 'Selecione o status',
  packsRegistration: 'Cadastro de Packs',
  packImage: 'Imagem do Pack',
  packDetails: 'Detalhes do Pack',
  unitPrice: 'Preço Unit.',
  subtotal: 'Subtotal',
  remove: 'Remover',
  searchProduct: 'Buscar produto...',
  productAlreadyAdded: 'Produto já adicionado',
  selectedProducts: 'Produtos selecionados',
  pricingMethod: 'Forma de Precificação do Pack',
  fixedPriceLabel: 'Preço Fixo',
  discountPercentageLabel: 'Percentual de Desconto',
  finalPackValue: 'Valor Final do Pack',
  percentDiscountLabel: '% de Desconto',
  originalPrice: 'Preço Original',
  newPrice: 'Novo Preço',
  totalOriginal: 'Total Original do Pack',
  totalCurrent: 'Total Atual do Pack',
  pricingRequired: 'Defina a forma de precificação antes de adicionar produtos',
  invalidDiscountPercent: 'Percentual deve ser entre 1 e 100',
  packExpired: 'Pack vencido, não pode ser habilitado',
  importPacksText1: 'Para que a importação funcione é necessário que:',
  importPacksText2: 'O arquivo pode estar no formato CSV ou XLSX (Excel), com o mesmo layout de colunas.',
  importPacksText3: 'Os dados do pack vão nas colunas A-E (Nombre, Fecha de Inicio, Fecha de Fin, Tipo de Precificacion, Valor), a coluna F fica em branco, e a tabela de itens vai ao lado nas colunas G-I (Código, Cantidad, Precio Unitario). O item 1 fica na mesma linha dos dados do pack; os demais itens continuam para baixo só nas colunas G-I.',
  importPacksText13: 'É possível importar mais de um pack no mesmo arquivo: basta repetir o bloco completo (linha de título e linha(s) de dados) quantas vezes forem necessárias. Uma linha com "----------" ou "==========" entre um pack e outro é opcional, mas ajuda a identificar visualmente onde um pack termina e o outro começa.',
  importPacksText4: 'É obrigatório preencher os campos: Nombre, Fecha de Inicio, Fecha de Fin, Tipo de Precificacion, Valor',
  importPacksText5: 'O campo Nombre precisa ser único, ou seja, não é possível criar um pack com o mesmo nome de outro já cadastrado, nem repetir o mesmo nome duas vezes dentro do mesmo arquivo',
  importPacksText6: 'O campo Tipo Precificacion deve ser Fijo ou Porcentual (e, se for Porcentual, o Valor deve estar entre 0 e 100)',
  importPacksText10: 'Os campos Fecha de Inicio e Fecha de Fin devem ser informados no formato DD/MM/YYYY',
  importPacksText7: 'O campo Valor deve receber o valor correspondente ao tipo. Se for Fijo, é o preço final; se for Porcentual, é o percentual aplicado sobre o preço original de cada item',
  importPacksText8: 'O campo Código deve conter o código de um item obrigatoriamente cadastrado no CheckBuy, sem se repetir dentro do mesmo pack',
  importPacksText9: 'O campo Cantidad deve conter a quantidade daquele item no pack',
  importPacksText11: 'O campo Precio Unitario é opcional e permite especificar o preço de cada produto no pack. Se não for informado, o sistema utilizará o preço da base de dados.',
  importPacksText12: 'A importação é tudo ou nada: se qualquer pack do arquivo tiver um erro, nenhum pack do arquivo é criado. Todos os erros encontrados são exibidos juntos, para você corrigir de uma vez.',
  packsNotAdded: 'Packs não adicionados',
  packNotFound: 'Pack não encontrado',
  packCreated: 'Pack criado com sucesso',
  packUpdated: 'Pack atualizado com sucesso',
  deletePack: 'Deseja excluir o pack?',
  importPacks: 'Importar Packs',
  importPacksError_PackNameRequired: 'O nome do pack é obrigatório.',
  importPacksError_PackNameAlreadyExists: 'Já existe um pack cadastrado com este mesmo nome. Não é possível importar. Altere o nome e tente novamente.',
  importPacksError_DateEffectiveFormat: 'A data de início (Fecha de Inicio) deve ser informada no formato DD/MM/YYYY.',
  importPacksError_DateExpirationFormat: 'A data final (Fecha de Fin) deve ser informada no formato DD/MM/YYYY.',
  importPacksError_DateExpirationBeforeEffective: 'A data final não pode ser anterior à data de início. Ajuste e tente novamente.',
  importPacksError_PriceInvalid: 'O valor do pack, seja fixo ou percentual, não pode ser zero ou nulo. Não é possível importar. Ajuste e tente novamente.',
  importPacksError_ProductNotRegistered: 'O produto com o código %{code} não está cadastrado no Checkbuy. Não é possível continuar. Corrija e tente novamente!',
  importPacksError_QuantityInvalid: 'A quantidade do produto a incluir no Pack não pode ser nula ou zero. Não é possível continuar. Ajuste e tente novamente.',
  importPacksError_FileFormat: 'O arquivo não está no formato esperado (título do pack, dados do pack, título dos itens e os itens). Verifique o modelo e tente novamente.',
  importPacksError_PackHeaderMismatch: 'Não foi encontrada a linha de título do pack ("Nombre;Fecha de Inicio;Fecha de Fin;Tipo de Precificacion;Valor") no início do arquivo ou de um bloco de pack. Baixe o modelo e confira o layout.',
  importPacksError_ItemsHeaderMismatch: 'Não foi encontrada a linha de título dos itens ("Código;Cantidad;Precio Unitario") na posição esperada. Baixe o modelo e confira o layout.',
  importPacksError_NoItems: 'O pack precisa ter pelo menos um item (produto).',
  importPacksError_PriceTypeInvalid: 'O campo Tipo Precificacion deve ser exatamente "Fijo" ou "Porcentual".',
  importPacksError_PercentageOutOfRange: 'Quando o Tipo Precificacion é Porcentual, o Valor deve estar entre 0 e 100.',
  importPacksError_ProductCodeRequired: 'O código do produto (Código) é obrigatório em todos os itens do pack.',
  importPacksError_DuplicateProductCode: 'O produto com o código %{code} aparece mais de uma vez no mesmo pack. Remova as linhas repetidas e tente novamente.',
  importPacksError_UnitPriceInvalid: 'O Precio Unitario informado não é válido. Deve ser um número maior ou igual a zero, ou ficar em branco.',
  importPacksError_DuplicatePackNameInFile: 'Este nome de pack aparece mais de uma vez no mesmo arquivo. Cada pack do arquivo precisa ter um nome único.',
  importPacksError_ValidationFailed: 'Foram encontrados os erros a seguir. Nenhum pack foi importado — corrija todos os pontos e tente novamente:',
  importPacksError_PricingUnavailable: 'Não foi possível obter o preço deste produto no momento (serviço de preços indisponível). Este pack não foi importado — tente novamente mais tarde, ou informe manualmente o Precio Unitario de todos os itens deste pack.',
  importPacksResultsImportedTitle: 'Packs importados com sucesso:',
  importPacksResultsSkippedTitle: 'Packs não importados:',
  dragAndDropPacksErrorTitle: 'Packs não adicionados:',
  dragAndDropPacksErrorPackName_NotInformed: 'Nome do pack não informado',
  dragAndDropPacksErrorDateEffective_NotInformed: 'Data de vigência não informada',
  dragAndDropPacksErrorDateEffective_InvalidFormat: 'Data de vigência com formato inválido (DD/MM/YYYY)',
  dragAndDropPacksErrorDateExpiration_NotInformed: 'Data de validade não informada',
  dragAndDropPacksErrorDateExpiration_InvalidFormat: 'Data de validade com formato inválido (DD/MM/YYYY)',
  dragAndDropPacksErrorPriceType_NotInformed: 'Forma de precificação não informada',
  dragAndDropPacksErrorPriceType_InvalidValue: 'Forma de precificação inválida, deve ser 0 (preço fixo) ou 1 (percentual de desconto)',
  dragAndDropPacksErrorPrice_NotInformed: 'Valor do pack não informado',
  dragAndDropPacksErrorPrice_InvalidValue: 'Valor do pack inválido',
  dragAndDropPacksErrorStatus_NotInformed: 'Status não informado',
  dragAndDropPacksErrorStatus_InvalidValue: 'Status inválido, deve ser 0 (ativo) ou 1 (inativo)',
  dragAndDropPacksErrorProductId_NotInformed: 'Código do produto não informado',
  dragAndDropPacksErrorProductId_NotFound: 'Produto não encontrado',
  dragAndDropPacksErrorQuantity_NotInformed: 'Quantidade não informada',
  dragAndDropPacksErrorQuantity_InvalidValue: 'Quantidade inválida, deve ser um número inteiro maior que 0',
};
